import React from 'react'
import '../App.css'

// speaker:
// 0: server
// 1: client

const backslash2br = (text) => {
    return text.split('\\').map((item, key) => {
        return <span key={key}>{item}<br/></span>
    })
}

const MessageOptionList = (props) => {
    // console.log(props)

    const optionDoms = props.options.map( x => <div className="message-option">{x}</div> )
    return (
        <div className="message-option-list">
            {optionDoms}
        </div>
    )
}

const SingleMessage = (props) => {
    // console.log(props)
    if (props.type === 'image') {
        return (
            <div className={props.speaker===0?"single-message-image--server":"single-message-image--client"}
                 onClick={() => {props.setImageUrl(props.text)}}>
                <img alt="" src={props.text} />
            </div>
        )
    }
    // else if (props.type === 'gif') {
    //     return (
    //         <div className={props.speaker===0?"single-message-image--server":"single-message-image--client"}
    //              onClick={() => {props.setImageUrl('/images/nightkeepers.gif')}}>
    //             <img alt="" src={props.text} />
    //         </div>
    //     )
    // }
    else if (props.type === 'question'){
        const optionDoms = props.data.map( 
            x => (
                <div className="server-message-option"
                    onClick={() => {props.sendMessage({type: "text", text: x, data: x});}}
                >{x}</div>  )
            )
        return (
            <div className={props.speaker===0?"single-message--server":"single-message--client"}>
                {props.text}
                {optionDoms}
            </div>
        )
    }
    else if (props.type === 'youtube') {
		//顯示官網版本
        //return (
        //    <div className="single-message-youtube">
        //        <img alt="" src={`https://i.imgur.com/K3QFMjs.jpg`} /> 
        //        <div className="single-message-youtube__wrapper">
        //            {props.text}
        //            <div className="single-message-youtube__button"
        //                onClick={() => {window.open(`${props.data}`, "_blank")}}>前往</div>
        //        </div>
        //    </div>
        //)
        return (
            <div className="single-message-youtube">
				<img alt="" src={`https://img.youtube.com/vi/${props.data}/mqdefault.jpg`} />
                <div className="single-message-youtube__wrapper">
                    {props.text}
                    <div className="single-message-youtube__button"
						onClick={() => {window.open(`https://www.youtube.com/watch?v=${props.data}`, "_blank")}}>收聽</div>
                </div>
            </div>
        )
    }
    else { // props.type === 'text
        return (
            <div className={props.speaker===0?"single-message--server":"single-message--client"}>
                {props.text}
            </div>
        )
    }
    
    
    
}

export default SingleMessage;
